/**
 * Steps for the extension/suspension approval modal
 */
export const STEPS = {
  MAIN: "main",
  DENY: "deny",
  APPROVE: "approve",
  SEND_TO_LEAD: "send_to_lead",
} as const;
export type STEPS = (typeof STEPS)[keyof typeof STEPS];

export interface AcceptButtonDetails {
  label: string;
  variant:
    | "ghost"
    | "default"
    | "secondary"
    | "tertiary"
    | "quiet"
    | "ghost-blue"
    | "danger-primary"
    | "danger-secondary"
    | "danger-tertiary"
    | "alpha-neutral"
    | "input-helper"
    | null
    | undefined;
  disabled?: boolean;
  isLoading?: boolean;
}
